import React from 'react'

import {getStartOffset, useMarginRef} from '../margin-provider'
import Drawer from './Drawer'
import {classes} from './DrawerDesktop.classes'

type Props = {
  className?: string
}

const DrawerDesktop: React.FC<React.PropsWithChildren<Props>> = ({children}) => {
  const ref = useMarginRef<HTMLDivElement>(getStartOffset)

  return (
    <Drawer ref={ref} className={classes.container}>
      {children}
    </Drawer>
  )
}

export default DrawerDesktop
